import BaseModelInputControl from "@/models/BaseModelInputControl.js";
export const GridConfig = {
	list: BaseModelInputControl.list,
    columns: BaseModelInputControl.columns,
	//query:BaseModelInputControl.query,

	grid: {
		gridId: 'InputControlGrid',
		height: 500,
		checkbox: false,
		actionsColumnWidth:20,
		edit: true,
		delete: true,
		pageSize: 100,
        groupable: true,
		document:false,
		sort: [{ field: "Field", dir: "asc" },{ field: "Option", dir: "asc" }]
	}
}
export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnAddInputControl",
			type: "button",
			text: "Add InputControl",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
	]
}